import { Map } from 'immutable';

import Home from './scenes/Home';
import Management from './scenes/Management';
import HomeDetails from './scenes/Home/details';
import BrandDetail from './scenes/Brands/details';
import ManagementDetails from './scenes/Management/details';
import HomeAdd from './scenes/Home/add';
import BrandAdd from './scenes/Brands/add';
import ManagementAdd from './scenes/Management/add';
import Box from './scenes/Box';
import Craftsman from './scenes/Craftsman';
import CraftsmanDetails from './scenes/Craftsman/details';
import CraftsmanAdd from './scenes/Craftsman/add';
import UserManagerAdd from './scenes/UserManager/add';
import UserManager from './scenes/UserManager';
import UserManagerDetails from './scenes/UserManager/details';
import TicketFhe from './scenes/TicketFhe';
import TicketFheDetails from './scenes/TicketFhe/details';
import TicketDetails from './scenes/Ticket/details';
import Products from './scenes/Products';
import Brands from './scenes/Brands';
import ProductsDetails from './scenes/Products/details';
import ProductAdd from './scenes/Products/add';
import Issue from './scenes/Issues';
import IssueDetails from './scenes/Issues/details';
import IssueCreate from './scenes/Issues/create';
import PushNotification from './scenes/PushNotification';
import PushNotificationDetails from './scenes/PushNotification/details';
import PushNotificationAdd from './scenes/PushNotification/add';

export default env =>
    new Map({
        /** Home */
        '/home': {
            firstPage: true,
            must_logged: true,
            component: Home,
            right: 'homeList',
            children: new Map({
                /** Home detail */
                '/add': {
                    index: 1,
                    must_logged: true,
                    component: HomeAdd,
                    right: 'homeAdd'
                },
                /** Home detail */
                '/detail/:homeId': {
                    must_logged: true,
                    component: HomeDetails,
                    right: 'homeDetails'
                }
            })
        },
        /** Management */
        '/management': {
            must_logged: true,
            component: Management,
            right: 'managementList',
            children: new Map({
                /** Management detail */
                '/detail/:managementId': {
                    must_logged: true,
                    component: ManagementDetails,
                    right: 'managementDetails'
                },
                /** Management add */
                '/add': {
                    must_logged: true,
                    component: ManagementAdd,
                    right: 'managementAdd'
                }
            })
        },
        /** Box */
        '/box': {
            must_logged: true,
            component: Box,
            right: `boxList_${env}`
        },

        /** Brands */
        '/brands': {
            must_logged: true,
            component: Brands,
            children: new Map({
                /** Home detail */
                '/add': {
                    index: 1,
                    must_logged: true,
                    component: BrandAdd,
                },
                /** Home detail */
                '/detail/:brandId': {
                    must_logged: true,
                    component: BrandDetail,
                }
            })
        },

        /** Craftsman */
        '/craftsman': {
            must_logged: true,
            component: Craftsman,
            right: 'craftsmanList',
            children: new Map({
                /** Craftsman detail */
                '/detail/:craftsmanId': {
                    must_logged: true,
                    component: CraftsmanDetails,
                    right: 'craftsmanDetails'
                },
                /** Craftsman detail */
                '/add': {
                    must_logged: true,
                    component: CraftsmanAdd,
                    right: 'craftsmanAdd'
                },
                /** Ticketing details */
                '/ticket/:id': {
                    must_logged: true,
                    component: TicketDetails,
                    right: 'ticketDetails'
                }
            })
        },

        /** User */
        '/user-manager': {
            must_logged: true,
            component: UserManager,
            right: 'userManagerList',
            children: new Map({
                // User detail
                '/detail/:userManagerId': {
                    must_logged: true,
                    component: UserManagerDetails,
                    right: 'userManagerDetails'
                },
                /** UserManager detail */
                '/add': {
                    must_logged: true,
                    component: UserManagerAdd,
                    right: 'userManagerAdd'
                }
            })
        },
        /** Ticketing FHE */
        '/fheticket': {
            must_logged: true,
            component: TicketFhe,
            right: 'fheTicketList',
            children: new Map({
                /** Ticketing FHE details */
                '/:id': {
                    must_logged: true,
                    component: TicketFheDetails,
                    right: 'fheTicketDetails'
                }
            })
        },
        /** Products */
        '/products': {
            must_logged: true,
            component: Products,
            right: 'productsList',
            children: new Map({
                /** Products details */
                '/:homeId/:productType/:productIdentifier': {
                    must_logged: true,
                    component: ProductsDetails,
                    right: 'productsDetails'
                },
                /** Ajout d'un produit */
                '/add': {
                    must_logged: true,
                    component: ProductAdd,
                    right: 'addProduct'
                }
            })
        },

        '/issues': {
            must_logged: true,
            component: Issue,
            right: 'issuesList',
            children: new Map({
                '/:issueId/projects/:projectId': {
                    must_logged: true,
                    component: IssueDetails,
                    right: 'issueDetails'
                },
                '/create': {
                    must_logged: true,
                    component: IssueCreate,
                    right: 'issueCreate'
                }
            })
        },

        /** Notifications Push */
        '/push-notifications': {
            must_logged: true,
            component: PushNotification,
            right: 'pushNotificationList',
            children: new Map({
                /** Notifications Push add */
                '/add': {
                    index: 1,
                    must_logged: true,
                    component: PushNotificationAdd,
                    right: 'pushNotificationAdd'
                },
                /** Notifications Push details */
                '/detail/:pushNotificationId': {
                    must_logged: true,
                    component: PushNotificationDetails,
                    right: 'pushNotificationDetails'
                }
            })
        }
    });



// WEBPACK FOOTER //
// ./environments/genericEnv/routes.js